import styled from 'styled-components';

import MaskedInputComponent from 'react-text-mask';

export const MaskedInput = styled(MaskedInputComponent)`
  &&&& {
    border: unset;
  }
  ${({ error, theme }) => (error && `
      &&&& {
        background-color: ${theme.color.inputBackgroundError}; 
        color: ${theme.color.error};
        box-shadow: none;
      }`)}
`;
